import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {environment} from '../environments/environment';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {authStore} from '@app/core-portal';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  public loading$: Observable<boolean>;
  public loaded$: Observable<boolean>;
  public loggedIn$: Observable<boolean>;

  constructor(
    private titleService: Title,
    private store: Store<any>
  ) {
    this.titleService.setTitle(environment.title);
    this.loading$ = this.store.pipe(select(authStore.selectors.selectLoading));
    this.loaded$ = this.store.pipe(select(authStore.selectors.selectLoaded));
    this.loggedIn$ = this.store.pipe(select(authStore.selectors.selectLoggedIn));
  }
}
